// The "Travel info" picto of an OTO Individual placement, as the backend computes it: grey while
// the parents have not sent their voyage individuel, red while the provider has not recorded who
// picks the youth up, green once it has. No state without accueil transfert.
export enum OtoIndividualTravelInfoStateEnum {
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  PERSON_MISSING = 'PERSON_MISSING',
  COMPLETED = 'COMPLETED'
}
